import './index.scss'
import { observer } from 'mobx-react'
import Parallax from '../../../common/Parallax'
import ProductItem from '../ProductItem'
import ServiceItem from '../ServiceItem'
import ServiceItem2 from '../ServiceItem2'
import { useEffect, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import { SolutionTab } from '../../about/Solutions'
import { ReactComponent as Arrow } from '../../../../assets/arrow-left.svg'
import classNames from 'classnames'
import GlobalState from '../../../../stores/GlobalState'

const ProductsContent = observer(() => {
  const [width, setWidth] = useState(window.innerWidth)
  const [tab, setTab] = useState(0)

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  useEffect(() => {
    if (width <= 900) {
      if (!tab) {
        document.querySelector('.header')?.classList.add('light')
        document.querySelector('.navigation')?.classList.add('light')
      } else {
        document.querySelector('.header')?.classList.remove('light')
        document.querySelector('.navigation')?.classList.remove('light')
      }
    }
  }, [tab])

  let lang = GlobalState.currentLocale.lang.includes('En')
    ? '/en'
    : GlobalState.currentLocale.lang.includes('ру')
    ? '/ru'
    : ''

  if (!ContentState.products) return <></>
  return (
    <section className={classNames('products-content', !tab && 'dark')}>
      {width <= 900 && (
        <div className="products-content__title">
          {ContentState.products.title}
        </div>
      )}
      {width <= 900 && (
        <div className="we-block__solutions-tabs">
          {ContentState.products.tabs.map((s, i) => (
            <SolutionTab
              title={s}
              key={i}
              active={tab == i}
              setTab={(value) => setTab(i)}
            />
          ))}
        </div>
      )}
      <div
        className={classNames('products-content__col black', !tab && 'show')}
      >
        <div className="products-content__title">
          {ContentState.products.tabs[0]}
        </div>
        <div className="products-content__img">
          <Parallax
            src={
              ContentState.products.business.video
                ? ContentState.products.business.video!
                : ContentState.products.business.img!
            }
            poster={
              ContentState.products.business.video
                ? ContentState.products.business.poster!
                : ''
            }
            type={ContentState.products.business.video ? 'video' : 'img'}
          />
        </div>
        <div className="products-content__row">
          <div className="products-content__subtitle">
            {ContentState.products.business.products[0]?.title}
          </div>
          <div className="products-content__list products">
            {ContentState.products.business.products[0]?.list.map(
              (p: any, i: number) => (
                <ProductItem dt={p} key={i} isDark={true} />
              ),
            )}
          </div>
        </div>
        <div className="products-content__row">
          <div className="products-content__subtitle">
            {ContentState.products.business.services[0].title}
          </div>
          <div className="products-content__list services">
            {ContentState.products.business.services[0].list.map(
              (p: any, i: number) => (
                <ServiceItem dt={p} key={i} isDark={true} />
              ),
            )}
          </div>
        </div>
        <div className="products-content__row">
          <div className="products-content__subtitle">
            {ContentState.products.business.services2[0].title}
          </div>
          <div className="products-content__list services2">
            {ContentState.products.business.services2[0].list.map(
              (p: any, i: number) => (
                <ServiceItem2 dt={p} key={i} isDark={true} />
              ),
            )}
          </div>
        </div>
        <div className="products-content__row">
          <div className="products-content__subtitle">
            {ContentState.products.business.digital[0].title}
          </div>
          <div className="products-content__list services2">
            {ContentState.products.business.digital[0].list.map(
              (p: any, i: number) => (
                <ServiceItem2 dt={p} key={i} isDark={true} />
              ),
            )}
          </div>
        </div>

        <div className="products-content__bottom">
          <a className="button white" href={`${lang}/for-business`}>
            {ContentState.products.buttonText}
          </a>
        </div>
      </div>
      <div className={classNames('products-content__col', tab && 'show')}>
        <div className="products-content__title">
          {' '}
          {ContentState.products.tabs[1]}
        </div>
        <div className="products-content__img">
          <Parallax
            src={
              ContentState.products.foryou.video
                ? ContentState.products.foryou.video!
                : ContentState.products.foryou.img!
            }
            poster={
              ContentState.products.foryou.video
                ? ContentState.products.foryou.poster!
                : ''
            }
            type={ContentState.products.foryou.video ? 'video' : 'img'}
            openHere={true}
          />
        </div>
        <div className="products-content__row">
          <div className="products-content__subtitle">
            {ContentState.products.foryou.products[0].title}
          </div>
          <div className="products-content__list products">
            {ContentState.products.foryou.products[0].list.map((p, i) => (
              <ProductItem dt={p} key={i} isDark={false} />
            ))}
          </div>
        </div>
        <div className="products-content__row">
          <div className="products-content__subtitle">
            {ContentState.products.foryou.services[0].title}
          </div>
          <div className="products-content__list services">
            {ContentState.products.foryou.services[0].list.map((p, i) => (
              <ServiceItem dt={p} key={i} isDark={false} />
            ))}
          </div>
        </div>
        <div className="products-content__row">
          <div className="products-content__subtitle">
            {' '}
            {ContentState.products.foryou.services2[0].title}
          </div>
          <div className="products-content__list services2">
            {ContentState.products.foryou.services2[0].list.map((p, i) => (
              <ServiceItem2 dt={p} key={i} isDark={false} />
            ))}
          </div>
        </div>
        <div className="products-content__row">
          <div className="products-content__subtitle">
            {ContentState.products.foryou.digital[0].title}
          </div>
          <div className="products-content__list services2">
            {ContentState.products.foryou.digital[0].list.map((p, i) => (
              <ServiceItem2 dt={p} key={i} isDark={false} />
            ))}
          </div>
        </div>
        <div className="products-content__bottom">
          <a className="button black" href={`${lang}/for-you`}>
            {ContentState.products.buttonText}
          </a>
        </div>
      </div>
      {width <= 480 && (
        <div
          className="team__bottom-arrow"
          onClick={() => {
            window.scrollTo(0, 0)
          }}
        >
          <Arrow />
        </div>
      )}
    </section>
  )
})

export default ProductsContent
